// extracted by mini-css-extract-plugin
export default {"exampleRoot":"docExampleContent_exampleRoot__A-RAO","exampleContent":"docExampleContent_exampleContent__TRpfn"};